export default class message {
    static info = (msg, option) => { };
    static warn = (msg, option) => { };
    static success = (msg, option) => { };
    static error = (msg, option) => { };
}
